<div class="edit-frequency-modal" *transloco="let t; prefix: 'compliance.library.editFrequencyModal'">

  <div class="edit-frequency-modal__header">
    <span>{{ t('title') }}</span>
    <button class="edit-frequency-modal__close" (click)="onCancel()">
      <i class="ph ph-x"></i>
    </button>
  </div>

  <div class="edit-frequency-modal__body">
    <div class="form-field">
      <label class="field-label">{{ t('fieldLabel') }}<span class="field-required">*</span></label>
      <div ngbDropdown class="field-dropdown" container="body">
        <button type="button" class="field-dropdown__toggle" [class.field-dropdown__toggle--placeholder]="!selectedFrequencyId" ngbDropdownToggle>
          <span class="toggle-label">{{ selectedFrequencyLabel }}</span>
          <i class="ph ph-caret-down"></i>
        </button>
        <div ngbDropdownMenu class="field-dropdown__menu">
          @for(freq of frequencies; track freq.id) {
            <button ngbDropdownItem (click)="selectedFrequencyId = freq.id">{{ freq.name | lookupLabel:'compliance.shared.frequencies' }}</button>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="edit-frequency-modal__footer">
    <button class="btn-cancel" (click)="onCancel()" [disabled]="isSaving">{{ 'common.cancel' | transloco }}</button>
    <button class="btn-save" (click)="onSave()" [disabled]="isSaving || !selectedFrequencyId || !isFrequencyChanged">
      @if(isSaving) {
        <span class="spinner-border spinner-border-sm me-1"></span>
      }
      {{ 'common.saveChanges' | transloco }}
    </button>
  </div>

</div>